import Content from './components/Content';
import FacePageHeader from '@/components/layout/FacePageHeader';
import Nav from '@/components/navigation/Nav';
import { PageFooter, PageHeader, PageMain, PageShell } from '@/components/layout/PageShell';

const FinancePage = () => {
  return (
    <PageShell
      contentVariant="face"
      footerMode="fixed"
      headerMode="static"
    >
      <PageHeader>
        <FacePageHeader />
      </PageHeader>

      <PageMain contentClassName="flex flex-1 flex-col gap-6">
        <Content />
      </PageMain>

      <PageFooter>
        <Nav />
      </PageFooter>
    </PageShell>
  );
};

export default FinancePage;